import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';

export default function PillFilters({ pills, value, onChange, counts = {} }) {
    return (
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
            {pills.map((p) => {
                const active = value === p.key;
                const count = counts[p.key];
                const label = count !== undefined ? `${p.label} (${count})` : p.label;
                const chip = (
                    <Chip
                        key={p.key}
                        label={label}
                        clickable
                        onClick={() => onChange(p.key)}
                        sx={{
                            fontWeight: 600,
                            fontSize: 12,
                            borderRadius: '20px',
                            bgcolor: active ? '#1565c0' : '#fff',
                            color: active ? '#fff' : '#666',
                            border: '1px solid',
                            borderColor: active ? '#1565c0' : '#e0e0e0',
                            ...(p.danger && !active && { borderColor: '#ef4444', color: '#c62828', bgcolor: '#fff5f5' }),
                            '&:hover': { borderColor: '#aaa' },
                        }}
                    />
                );
                // Optional per-pill explanation of what the count includes.
                return p.info
                    ? <Tooltip key={p.key} title={p.info} arrow placement='top'>{chip}</Tooltip>
                    : chip;
            })}
        </Box>
    );
}
